export const ruleConstants = {
  ACL_RULE_LIST_REQUEST: 'ACL_RULE_LIST_REQUEST',
  ACL_RULE_LIST_SUCCESS: 'ACL_RULE_LIST_SUCCESS',
  ACL_RULE_LIST_FAILURE: 'ACL_RULE_LIST_FAILURE',
  ACL_RULE_LIST_CHANGED: 'ACL_RULE_LIST_CHANGED',
  ACL_RULE_LIST_PAGINATION: 'ACL_RULE_LIST_PAGINATION',

  ACL_RULE_LOAD_REQUEST: 'ACL_RULE_LOAD_REQUEST',
  ACL_RULE_LOAD_SUCCESS: 'ACL_RULE_LOAD_SUCCESS',
  ACL_RULE_LOAD_FAILURE: 'ACL_RULE_LOAD_FAILURE',

  ACL_RULE_SAVE_REQUEST: 'ACL_RULE_SAVE_REQUEST',
  ACL_RULE_SAVE_SUCCESS: 'ACL_RULE_SAVE_SUCCESS',
  ACL_RULE_SAVE_FAILURE: 'ACL_RULE_SAVE_FAILURE',
};
